import React, { useCallback, useContext, useEffect, useState } from 'react';
import {
  Drawer,
  DrawerBody,
  DrawerContent,
  Stack,
  DrawerOverlay,
  Button,
  VStack,
  Center,
  Text,
  TableContainer,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  useDisclosure,
  Box,
  Grid,
  Flex,
} from '@chakra-ui/react';
import { AccountContext } from 'components/AccountContext';
import LoadingImg from 'components/LoadingImg';
import { api } from 'api/api';

const createDocumentFileName = ({ documentType, laudoId, link }) => {
  const extension = String(link).split('?')[0].toLowerCase().endsWith('.pdf') ? '' : '.pdf';
  const suffix = laudoId ? `-${laudoId}` : '';

  switch (documentType) {
    case 'certificate':
      return `atestado${suffix}${extension}`;
    case 'special-prescription':
      return `receituario-especial${suffix}${extension}`;
    case 'prescription':
    default:
      return `receituario${suffix}${extension}`;
  }
};

const redirectTo = (link, options = {}) => {
  return window?.ReactNativeWebView?.postMessage(
    JSON.stringify({
      service: true,
      action: options.action,
      openInBrowser: true,
      url: `${link}`,
      filename: options.filename,
      mimeType: options.mimeType,
      documentType: options.documentType,
    })
  );
};
const LinkButton = ({ link, type, text = null, laudoId }) => {
  const { user } = useContext(AccountContext);
  const { id_contrato, descricao_plano, titular } = user;

  const backgroundColor =
    titular === true && id_contrato === 0
      ? '#5AB2AE'
      : titular === false && id_contrato === 0
      ? '#5AB2AE'
      : titular === true && id_contrato > 0
      ? '#5AB2AE'
      : '#5AB2AE';

  const fileName = String(link).split('/').pop().split('?')[0];

  return (
    <Button
      w={'100%'}
      backgroundColor={backgroundColor}
      color={'#FFF'}
      onClick={() => {
        const documentType = type === 'Especial' ? 'special-prescription' : 'prescription';

        redirectTo(link, {
          action: 'downloadFile',
          documentType,
          filename: createDocumentFileName({ documentType, laudoId, link }),
          mimeType: 'application/pdf',
        });
      }}
    >
      {text ?? `${type} ${fileName}`}
    </Button>
  );
};

const ENDPOINT_DEOVITA =
  process.env.REACT_APP_ENVIRONMENT === 'production' ? process.env.REACT_APP_URL_DEOVITA_PROD : process.env.REACT_APP_URL_DEOVITA_TEST;

// Função para verificar se existem

function DrawerDocumentos({ laudoId, DisclosureButton, showReceitas, showAtestados }) {
  async function fetchDocumentos(ambulatorioLaudoId) {
    if (!ambulatorioLaudoId) {
      throw new Error('Não foi identificado número do laudo');
    }

    try {
      const response = await fetch(`${ENDPOINT_DEOVITA}/deovita/autocomplete/retrievePrescriptionAssignatureUrlsForLaudoId/${ambulatorioLaudoId}`);
      //console.log("response ", await response.json())
      return await response.json();
    } catch (err) {
      throw new Error(`Não foi possível carregar documentos do laudo "${ambulatorioLaudoId}": ${err.message}`);
    }
  }
  const [documentos, setDocumentosData] = useState();
  const disclosure = useDisclosure();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const [tabIndex, setTabIndex] = React.useState(0);

  useEffect(() => {
    if (disclosure.isOpen && !documentos) {
      (async () => {
        setError(null);
        setLoading(true);
        try {
          const data = await fetchDocumentos(laudoId);
          setDocumentosData(data);
          // throw new Error("Deu errado");
        } catch (error) {
          setError(error.message);
        } finally {
          setLoading(false);
        }
      })();
    }
  }, [disclosure.isOpen, documentos, laudoId]);

  const ReceituariosSimplesAssinados = () => {
    if ('receituario_simples_assinado' in documentos && documentos.receituario_simples_assinado.length > 0) {
      return (
        <>
          {documentos.receituario_simples_assinado.map((e, id) => (
            <LinkButton link={e} type={'Receituário'} text={'Baixar receita simples'} laudoId={laudoId} />
          ))}
        </>
      );
    } else {
      return (
        <Center>
          <Text>Não há receituários disponíveis</Text>
        </Center>
      );
    }
  };

  const ReceituarioEspecialAssinado = () => {
    if ('receituario_especial_assinado' in documentos && documentos.receituario_especial_assinado.length > 0) {
      return (
        <>
          {documentos.receituario_especial_assinado.map((e, id) => (
            <LinkButton link={e} type={'Especial'} text={'Baixar receita especial'} laudoId={laudoId} />
          ))}
        </>
      );
    } else {
      return (
        <Center>
          <Text textAlign={'center'}>Não há receituários especiais disponíveis</Text>
        </Center>
      );
    }
  };

  useEffect(() => {
    setDocumentosData(documentos);
  }, [documentos]);

  const getDeviceInfo = () => {
    const userAgent = navigator.userAgent;

    if (/android/i.test(userAgent)) return 'Android';
    if (/iPhone|iPad|iPod/i.test(userAgent)) return 'iOS';
    if (/Macintosh|Mac OS X/i.test(userAgent)) return 'MacOS';
    if (/Windows/i.test(userAgent)) return 'Windows';
    if (/Linux/i.test(userAgent)) return 'Linux';

    return 'Desconhecido';
  };

  const [recetuario_especial, setReceituarioEspecial] = useState(false);
  const [recetuario_especial_link, setReceituarioEspecialLink] = useState('');
  const [recetuario_simples, setReceituarioSimples] = useState(true);

  useEffect(() => {
    setReceituarioEspecial(recetuario_especial);
    setReceituarioEspecialLink(recetuario_especial_link);
  }, [recetuario_especial_link, recetuario_especial]);

  useEffect(() => {
    setReceituarioSimples(recetuario_simples);
  }, [recetuario_simples]);
  

  return (
    <>
      {DisclosureButton ? (
        <Box
          onClick={() => {
            disclosure.onOpen();
          }}
        >
          <DisclosureButton></DisclosureButton>
        </Box>
      ) : (
        <Flex flexDirection={'column'} gap={2}>
          <Flex gap={2}>
            {showReceitas && recetuario_simples && (
              <Button
                isFullWidth
                bg="#5AB2AE"
                size="xs"
                color={'white'}
                borderRadius={10}
                p={6}
                onClick={() => {
                  (async () => {
                    setError(null);
                    setLoading(true);
                    try {
                      let data = documentos;
                      if (!data) {
                        data = await fetchDocumentos(laudoId);
                        setDocumentosData(data);
                      }

                      if (data?.receituario_especial_assinado?.length) {
                        setReceituarioEspecial(true);
                        setReceituarioEspecialLink(data?.receituario_especial_assinado?.at(0));
                      }

                      if (data?.receituario_simples_assinado?.length) {
                        const url = data?.receituario_simples_assinado?.at(0);
                        if (url) {
                          redirectTo(url, {
                            action: 'downloadFile',
                            documentType: 'prescription',
                            filename: createDocumentFileName({ documentType: 'prescription', laudoId, link: url }),
                            mimeType: 'application/pdf',
                          });
                          //window?.open(url, '_blank');
                        }
                      } else {
                        setReceituarioSimples(false);
                      }

                      /*if (data?.receituario_simples_assinado?.length || data?.receituario_especial_assinado?.length) {
                        const urlSimples = data?.receituario_simples_assinado?.at(0);
                        const urlEspecial = data?.receituario_especial_assinado?.at(0);
                        if (urlSimples) {
                          redirectTo(urlSimples);
                          //window?.open(urlSimples, '_blank');
                        }

                        if (urlEspecial) {
                          redirectTo(urlEspecial);
                          //window?.open(urlEspecial, '_blank');
                        }
                      } else {
                        throw new Error('Não foi possível baixar a receita. Por favor, tente novamente ou entre em contato com nosso suporte.');
                      }*/
                    } catch (error) {
                      console.error(error);
                      setError('Não foi possível carregar documentos. Por favor, tente novamente mais tarde ou contacte nosso suporte.');
                    } finally {
                      setLoading(false);
                    }
                  })();
                }}
                isLoading={loading}
                disabled={loading || error}
              >
                {"Baixar\nreceituário"}
              </Button>
            )}

            {showAtestados && (
              <Button
                isFullWidth
                bg="#5AB2AE"
                color={'white'}
                size="xs"
                borderRadius={10}
                p={6}
                onClick={() => {
                  (async () => {
                    setError(null);
                    setLoading(true);
                    try {
                      let data = documentos;
                      if (!data) {
                        data = await fetchDocumentos(laudoId);
                        setDocumentosData(data);
                      }

                      if (data?.Atestado_assinado?.length) {
                        const url = data?.Atestado_assinado?.at(0);
                        /*if (getDeviceInfo() !== 'iOS') {
                          window?.ReactNativeWebView?.postMessage(
                            JSON.stringify({
                              service: true,
                              openInBrowser: true,
                              url,
                            })
                          );
                          window?.open(url, '_blank')?.focus();
                          return;
                        }
                        setTimeout(() => {
                          
                        }, 500); */
                        if (url) {
                          redirectTo(url, {
                            action: 'downloadFile',
                            documentType: 'certificate',
                            filename: createDocumentFileName({ documentType: 'certificate', laudoId, link: url }),
                            mimeType: 'application/pdf',
                          });
                          //window?.open(url, '_blank');
                        }
                      } else {
                        throw new Error('Não foi possível baixar o atestado. Por favor, tente novamente ou entre em contato com nosso suporte.');
                      }
                    } catch (error) {
                      setError('Não foi possível carregar documentos. Por favor, tente novamente mais tarde ou contacte nosso suporte.');
                    } finally {
                      setLoading(false);
                    }
                  })();
                }}
                isLoading={loading}
                disabled={loading || error}
              >
                Baixar <br />
                atestados
              </Button>
            )}
          </Flex>
          {recetuario_especial && (
            <>
              <Button
                isFullWidth
                bg="#5AB2AE"
                size="xs"
                color={'white'}
                borderRadius={10}
                p={6}
                onClick={() => {
                  (async () => {
                    setError(null);
                    setLoading(true);
                    try {
                      redirectTo(recetuario_especial_link, {
                        action: 'downloadFile',
                        documentType: 'special-prescription',
                        filename: createDocumentFileName({
                          documentType: 'special-prescription',
                          laudoId,
                          link: recetuario_especial_link,
                        }),
                        mimeType: 'application/pdf',
                      });
                    } catch (error) {
                      console.error(error);
                      setError('Não foi possível carregar documentos. Por favor, tente novamente mais tarde ou contacte nosso suporte.');
                    } finally {
                      setLoading(false);
                    }
                  })();
                }}
                isLoading={loading}
                disabled={loading || error}
              >
                Baixar <br />
                receituário especial
              </Button>
            </>
          )}
        </Flex>
      )}

      {error && (
        <Text fontSize={10} fontWeight={'bold'} textAlign={'center'} color={'red.700'}>
          {error}
        </Text>
      )}

      {documentos?.receituario_simples_assinado?.length && documentos?.receituario_especial_assinado?.length && (
        <Flex flexDirection={'column'} gap={2}>
          <ReceituariosSimplesAssinados />
          <ReceituarioEspecialAssinado />
        </Flex>
      )}

      {/* <Drawer isOpen={disclosure.isOpen} onClose={disclosure.onClose} placement="bottom">
        <DrawerOverlay />
        <DrawerContent borderTopRadius={20} h="70%">
          <DrawerBody>
            <Tabs isFitted index={tabIndex} onChange={(index) => setTabIndex(index)}>
              <TabList>
                <Tab
                  style={
                    tabIndex === 0
                      ? {
                          color: '#5AB2AE',
                          borderColor: 'orange',
                        }
                      : {}
                  }
                >
                  Receituários
                </Tab>
                <Tab
                  style={
                    tabIndex === 1
                      ? {
                          color: '#5AB2AE',
                          borderColor: 'orange',
                        }
                      : {}
                  }
                >
                  Atestados
                </Tab>
              </TabList>
              {loading ? (
                <Center p={20}>
                  <LoadingImg />
                </Center>
              ) : error ? (
                <Center
                  px={4}
                  py={4}
                  my={4}
                  rounded={'2xl'}
                  textColor={'red.800'}
                  flexDir={'column'}
                  gap={4}
                  bgColor={'red.100'}
                  textAlign={'center'}
                >
                  <Text fontSize={'sm'}>Ocorreu um erro ao carregar documentos. Tente novamente mais tarde.</Text>
                  <Text fontSize={'xs'} textColor={'red.300'}>
                    {error}
                  </Text>
                </Center>
              ) : (
                <TabPanels>
                  <TabPanel>
                    <VStack>
                      <ReceituariosSimplesAssinados />
                      <ReceituarioEspecialAssinado />
                    </VStack>
                  </TabPanel>

                  <TabPanel>
                    <AtestadosAssinados />
                  </TabPanel>
                </TabPanels>
              )}
            </Tabs>
          </DrawerBody>
        </DrawerContent>
      </Drawer> */}
    </>
  );
}

export default DrawerDocumentos;
